module.exports = "/static/assets/f14af652813faa3ac863c23fe6418b12.png";